import PencilIcon from '@components/icons/Pencil.svg';
import TrashBin from '@components/icons/TrashBin.svg';
import { ModalNamesEnum } from 'app/types/enums/ModalNamesEnum';
import { usePageContext } from '@pages/User/NewJobPage/providers/PageProvider';
import { useAuthContext } from '@providers/AuthProvider';
import { useModalContext } from '@providers/ModalProvider';
import { routes } from '@routes';
import { TUser } from 'app/types/entities/TUser';

import { StyledBlock } from './styles/StyledBlock';
import { StyledLink } from './styles/StyledLink';

export const AssigneeBlock = () => {
  const { organization } = useAuthContext();
  const { openModal, closeModal } = useModalContext();
  const { form, setForm, job, setJob } = usePageContext();

  const setAssignee = (assignee: TUser | null, assigneeComment: string) => {
    if (job) {
      setForm({
        ...form,
        item: {
          ...form.item,
          assigneeComment,
          assigneeId: assignee?.id ?? undefined,
          draftAssigneeId: undefined,
        },
      });
      setJob({
        ...job,
        assignee: assignee ?? undefined,
        draftAssignee: undefined,
      });
    }
    closeModal();
  };

  const editAssignee = () => {
    openModal(ModalNamesEnum.GetAssigneeModal, {
      initialValue: job?.assignee || job?.draftAssignee,
      onSuccess: (assignee: TUser | null, comment: string) => setAssignee(assignee, comment),
    });
  };

  const description = <p>Assignments will trigger when the job has completed processing</p>;

  const assignee = job?.assignee || job?.draftAssignee;

  return (
    <StyledBlock title="Assignee" description={description}>
      {assignee ? (
        <div className="assignee-wrapper">
          <div className="assignee">
            <StyledLink to={routes.userDetails.make(organization?.slug ?? '', assignee?.id)}>
              <p className="assignName">
                {assignee?.name} {assignee?.lastname}
              </p>
              <p className="assignEmail">{assignee?.email || ''}</p>
            </StyledLink>
          </div>
          <button className="edit-assignee" type="button" onClick={() => editAssignee()}>
            <PencilIcon className="text-[var(--color-text-muted)] hover:text-[var(--color-accent)] cursor-pointer" />
          </button>
          <button className="remove-assignee" type="button" onClick={() => setAssignee(null, '')}>
            <TrashBin />
          </button>
        </div>
      ) : null}
      {!assignee ? (
        <button className="add-assignee" type="button" onClick={() => editAssignee()}>
          + Add Assignee
        </button>
      ) : null}
    </StyledBlock>
  );
};
